export default __webpack_public_path__ + "static/media/shutterstock_746700040_estudiantes_2.2a4575b3.webp";